export const SET_NAVIGATION_ROUTE = 'SET_NAVIGATION_ROUTE'
export const SET_USERDATA = 'SET_USERDATA'
export const LOGOUT = 'LOGOUT'
export const SET_VA_SELECTED = 'SET_VA_SELECTED'